/* ==========================================================================
   MaxGlows — bundle cards helper                                 2026-09-04

   Companion to assets/mg-bundle.css. For the three-card variant picker on
   the spray page it:
     - tags each card (mg-hero for the 2+1 bundle, mg-side for the others),
     - writes a per-bottle price ("₪79 לבקבוק") from the price the card is
       currently showing — Payeo rewrites that price when the subscription
       box is toggled, so a MutationObserver keeps the number in step,
     - on the hero card, adds "חוסכים ₪X לעומת בקבוק בודד".
   Nothing here touches the form, the cart or Payeo; it only reads the
   displayed prices and adds text.
   ========================================================================== */
(function () {
  'use strict';

  function num(text) {
    var m = String(text || '').replace(/[,‏‎]/g, '').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }
  function symbol(text) {
    var m = String(text || '').match(/[^\d\s.,‏‎]+/);
    return m ? m[0] : '₪';
  }
  function money(sym, v) {
    return sym + Math.round(v);
  }
  // "קנה 2 קבל 1 מתנה" -> 3 bottles, "קנה 1" -> 1
  function bottles(label) {
    var n = 0, m = String(label || '').match(/\d+/g);
    if (!m) return 1;
    m.forEach(function (x) { n += parseInt(x, 10); });
    return n || 1;
  }

  function decorate(picker) {
    var cards = picker.querySelectorAll('label.quantity-break');
    if (cards.length !== 3) return;
    var single = null; // displayed per-bottle price of the single bottle

    cards.forEach(function (card, i) {
      var label = card.querySelector('.quantity-break__label-text');
      var right = card.querySelector('.quantity-break__right');
      var priceEl = card.querySelector('.quantity-break__price');
      if (!label || !right || !priceEl) return;

      card.classList.toggle('mg-hero', i === 1);
      card.classList.toggle('mg-side', i !== 1);

      var qty = bottles(label.textContent);
      var shown = num(priceEl.textContent);
      if (isNaN(shown)) return;
      var sym = symbol(priceEl.textContent);
      var per = shown / qty;

      var perEl = right.querySelector('.mg-per');
      if (!perEl) {
        perEl = document.createElement('span');
        perEl.className = 'mg-per';
        right.insertBefore(perEl, right.firstChild);
      }
      var html = money(sym, per) + ' <small>לבקבוק</small>';
      if (perEl.innerHTML !== html) perEl.innerHTML = html;
      if (i === 0) single = per;

      if (i !== 1) return;

      var save = right.querySelector('.mg-save');
      if (!save) { save = document.createElement('span'); save.className = 'mg-save'; right.appendChild(save); }
      var saved = single != null ? single * qty - shown : NaN;
      var saveTxt = saved > 0 ? 'חוסכים ' + money(sym, saved) + ' לעומת בקבוק בודד' : '';
      if (save.textContent !== saveTxt) save.textContent = saveTxt;
    });
  }

  var scheduled = false;
  function run() {
    scheduled = false;
    document.querySelectorAll('.quantity-breaks--vertical[data-items="3"]').forEach(decorate);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  function init() {
    run();
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        // ignore our own writes
        if (t.nodeType === 1 && t.closest && t.closest('.mg-per,.mg-save')) continue;
        if (t.nodeType === 3 && t.parentNode && t.parentNode.closest && t.parentNode.closest('.mg-per,.mg-save')) continue;
        schedule();
        return;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
